import React from 'react';
import { FontPreload } from './components/FontPreload';
import { Hero } from './components/Hero';
import { ProofBar } from './components/ProofBar';
import { Testimonials } from './components/Testimonials';
import { FreezeMoment } from './components/FreezeMoment';
import { PainGrid } from './components/PainGrid';
import { BigIdea } from './components/BigIdea';
import { Mechanism } from './components/Mechanism';
import { ProductPresentation } from './components/ProductPresentation';
import { Volumes } from './components/Volumes';
import { Bonuses } from './components/Bonuses';
import { Urgency } from './components/Urgency';
import { Pricing } from './components/Pricing';
import { Transformation } from './components/Transformation';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { CostOfInaction } from './components/CostOfInaction';
import { Close } from './components/Close';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
import { BrassRule } from './components/Section';
import { MetaPixel } from './components/MetaPixel';
import { testimonialsPrimary, testimonialsSecondary } from './data/testimonials';
export function App() {
  return <div className="min-h-screen w-full bg-paper font-sans text-ink selection:bg-sage selection:text-white" data-id="element-0" data-mp="3recctgjguhe3">
      <FontPreload data-id="element-1" data-mp="7sxbo2oq39g" />
      <MetaPixel data-id="element-2" data-mp="2zllf11m4wkmq" />
      <main className="pb-24 lg:pb-0" data-id="element-3" data-mp="2zm4y4lnitf2c">
        <Hero data-id="element-4" data-mp="2zn6actg9w7ln" />
        <ProofBar data-id="element-5" data-mp="2znfyebhrc4op" />
        <Testimonials items={testimonialsPrimary} data-id="element-6" data-mp="33mf6g4yschkd" />
        <FreezeMoment data-id="element-7" data-mp="33mymth8sexwa" />
        <BrassRule data-id="element-8" data-mp="33oi152avuyvf" />
        <PainGrid data-id="element-9" data-mp="38m1iwc6shts4" />
        <BigIdea data-id="element-10" data-mp="38kqcs5pvg9xu" />
        <Mechanism data-id="element-11" data-mp="38k6tolohjfi8" />
        <BrassRule data-id="element-12" data-mp="38nunzn1r85y0" />
        <ProductPresentation data-id="element-13" data-mp="3dkuws5pznmst" />
        <Volumes data-id="element-14" data-mp="3dl4kfmnk9hvc" />
        <BrassRule data-id="element-15" data-mp="3dlnsmbnesrw6" />
        <Bonuses data-id="element-16" data-mp="3dm5vhr4ku4d2" />
        <Urgency data-id="element-17" data-mp="3dii6n5a2u64o" />
        <Pricing data-id="element-18" data-mp="nvssr1axyhud" />
        <BrassRule data-id="element-19" data-mp="nwc5m3lqig1j" />
        <Transformation data-id="element-20" data-mp="nv0z3w0wmu6q" />
        <Testimonials items={testimonialsSecondary} heading="More teachers, more rooms handled well" headingId="testimonials-secondary-heading" background="white" data-id="element-21" data-mp="nxn5hsc273nd" />
        <BrassRule data-id="element-22" data-mp="3uct43lu76r1j" />
        <Guarantee data-id="element-23" data-mp="3udaw269tuj3n" />
        <Faq data-id="element-24" data-mp="3ubrhck3tkg3z" />
        <BrassRule data-id="element-25" data-mp="3uc9l01st9wlx" />
        <CostOfInaction data-id="element-26" data-mp="3uevsk1fpcc45" />
        <Close data-id="element-27" data-mp="d4e5zu7z1ex8" />
      </main>
      <Footer data-id="element-28" data-mp="d3mlpfjtr3m9" />
      <StickyCta data-id="element-29" data-mp="d3cwvvain2i5" />
    </div>;
}